import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: "Webify IT Technologies",
    description: "Trainer-led IT programs and internships on live software projects in Hyderabad and Vijayawada. Students and trainers sign in here to reach the Webify academic portal.",
    url: getOrigin()
}
